module.exports = __webpack_public_path__ + "img/brosse-bordeaux.0e941e12.svg";